<template>
  <div>
    <wc-page-title title='Account Reconciliations'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' v-for='a in accounts' :key='a.id' class='mb-4'>
          <wc-data-box :title='a.name' :titleIcon="a.is_credit_card ? 'mdi-credit-card' : 'mdi-bank'"
            :titleIconColor='toolbarData.iconColor' :loading='isLoading' showAdd @add='newRec(a)'
            @toggleShowArchived='toggleShowArchived'>
            <v-data-table dense :items='recs.filter(r => r.account == a.id)' sort-by='to_date' sort-desc
              :headers='headers' :items-per-page='5' @click:row='openRec'>
              <template v-slot:item.from_date='{ item }'>
                {{ item.from_date | shortDate }}
              </template>
              <template v-slot:item.to_date='{ item }'>
                {{ item.to_date | shortDate }}
              </template>
              <template v-slot:item.is_locked='{ item }'>
                <v-tooltip right>
                  <template v-slot:activator='{ on }'>
                    <v-icon v-on='on' small :color="item.is_locked ? 'error' : 'grey lighten-2'">mdi-lock</v-icon>
                  </template>
                  <span v-if='item.is_locked'>Completed and Locked</span>
                  <span v-else>Not complete - in progress</span>
                </v-tooltip>
              </template>
              <template v-slot:item.end_balance='{ item }'>
                {{ item.end_balance | decMoney }}
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>

      <wc-dialog :showDialog='showDialog' :title='recTitle' :icon='toolbarData.icon' :iconColr='toolbarData.iconColor'
        width='350' :loading='isSaving' :disableButtons='!isFormValid' saveText='Continue' @cancel='showDialog = false'
        @save='saveRec'>
        <v-form v-model='isFormValid' ref='form'>
          <wc-datepicker label='From date:' required :disabled='!canSetFromDate'
            hint='Day after end of previous reconciliation' persistent-hint v-model='recCopy.from_date'></wc-datepicker>
          <br>
          <wc-datepicker label='To date:' required v-model='recCopy.to_date'></wc-datepicker>
          <br>
          <v-text-field label='Statement Ending balance' :rules='[rules.decimal]' v-model='recCopy.end_balance'
            hint='From the bank or credit card statement' persistent-hint></v-text-field>
        </v-form>
      </wc-dialog>
    </v-container>
  </div>
</template>

<script>
import reconciliationsAPI from '@/api/accounting';
import formRules from '@/mixins/formRules';
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'all-deposits',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    isSaving: false,
    isFormValid: false,
    showArchived: false,
    showDialog: false,
    testPicker: { date: '' },
    accounts: [],
    account_info: {},
    recs: [],
    currentDivision: {},
    recTitle: 'New Reconciliation',
    recOpeningBalance: 0,
    canSetFromDate: false,
    recCopy: {
      from_date: '',
      to_date: '',
      account: null,
      end_balance: ''
    },
    headers: [
      { text: 'Account', value: 'account_obj.name' },
      { text: 'Status', value: 'is_locked', left: 'left' },
      { text: 'Start Date', value: 'from_date', align: 'center', width: '150' },
      { text: 'End Date', value: 'to_date', align: 'center', width: '150' },
      { text: 'End Balance', value: 'end_balance', align: 'right', width: '150' }
    ]
  }),
  computed: {
    toolbarData() {
      return this.$store.state.icons.dataBox.bankRecs
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.isLoading = true
      this.accounts = await reconciliationsAPI.getReconciliationAccounts();
      for (let i = 0; i < this.accounts.length; i++) {
        this.recs = _.concat(this.recs, await reconciliationsAPI.getReconciliations(this.accounts[i].id))
      }
      this.isLoading = false
    },
    toggleShowArchived() {
      this.showArchived = !this.showArchived
    },
    resetRecCopy(account) {
      this.recCopy.date = null
      this.recCopy.account = account.id
      this.recCopy.end_balance = ''
    },
    newRec(account) {
      let recs = this.recs.filter(r => r.account === account.id)
      if (recs.length > 0) {
        this.canSetFromDate = false
        recs = _.orderBy(recs, 'to_date', 'desc')
        let from_date = moment(recs[0].to_date, 'YYYY-MM-DD').add(1, 'days')
        this.recOpeningBalance = recs[0].end_balance
        this.recCopy.from_date = from_date.format('YYYY-MM-DD').toString()
        this.recCopy.to_date = moment(from_date).day(6).format('YYYY-MM-DD').toString()
        this.recCopy.previous_reconciliation = null
        this.recCopy.account = account.id
        this.recCopy.end_balance = 0
      } else {
        this.canSetFromDate = true
        this.recOpeningBalance = 0
        this.recCopy.from_date = null
        this.recCopy.to_date = null
        this.recCopy.previous_reconciliation = null
        this.recCopy.account = account.id
        this.recCopy.end_balance = 0
      }
      this.showDialog = true
    },
    async saveRec() {
      this.isSaving = true
      let tmp = await reconciliationsAPI.createReconciliation(this.recCopy)
      this.openRec(tmp)
    },
    openRec(row) {
      this.$router.push({ name: 'ReconciliationDetail', params: { id: row.id } })
    }
  }
}
</script>
